/**
 * Performance Monitoring - Rastrea métricas de rendimiento
 * Core Web Vitals: LCP, FID, CLS
 */

class PerformanceMonitor {
  constructor() {
    this.metrics = {
      LCP: null,        // Largest Contentful Paint
      FID: null,        // First Input Delay
      CLS: null,        // Cumulative Layout Shift
      TTFB: null,       // Time to First Byte
      FCP: null,        // First Contentful Paint
    };
    this.initialized = false;
  }

  /**
   * Inicializar monitoreo de Web Vitals
   */
  init() {
    if (this.initialized) return;

    // Monitorear LCP (Largest Contentful Paint)
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const lastEntry = entries[entries.length - 1];
          this.metrics.LCP = lastEntry.renderTime || lastEntry.loadTime;
          console.log('LCP:', this.metrics.LCP, 'ms');
        });
        observer.observe({ entryTypes: ['largest-contentful-paint'] });
      } catch (e) {
        console.warn('Error monitoreando LCP:', e);
      }

      // Monitorear FID (First Input Delay)
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach((entry) => {
            this.metrics.FID = entry.processingDuration;
            console.log('FID:', this.metrics.FID, 'ms');
          });
        });
        observer.observe({ entryTypes: ['first-input'] });
      } catch (e) {
        console.warn('Error monitoreando FID:', e);
      }

      // Monitorear CLS (Cumulative Layout Shift)
      try {
        let clsValue = 0;
        const observer = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (!entry.hadRecentInput) {
              clsValue += entry.value;
              this.metrics.CLS = clsValue;
              console.log('CLS:', this.metrics.CLS);
            }
          }
        });
        observer.observe({ entryTypes: ['layout-shift'] });
      } catch (e) {
        console.warn('Error monitoreando CLS:', e);
      }
    }

    // Obtener TTFB (Time to First Byte)
    window.addEventListener('load', () => {
      const perfData = window.performance.timing;
      this.metrics.TTFB = perfData.responseStart - perfData.fetchStart;
      console.log('TTFB:', this.metrics.TTFB, 'ms');
    });

    // Obtener FCP (First Contentful Paint)
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach((entry) => {
            if (entry.name === 'first-contentful-paint') {
              this.metrics.FCP = entry.startTime;
              console.log('FCP:', this.metrics.FCP, 'ms');
            }
          });
        });
        observer.observe({ entryTypes: ['paint'] });
      } catch (e) {
        console.warn('Error monitoreando FCP:', e);
      }
    }

    this.initialized = true;
  }

  /**
   * Obtener todas las métricas
   */
  getMetrics() {
    return { ...this.metrics };
  }

  /**
   * Reportar métricas (para enviar a servidor)
   */
  reportMetrics(endpoint) {
    if (!endpoint) return;

    // Reportar al servidor después de load completo
    window.addEventListener('load', () => {
      setTimeout(() => {
        const metrics = this.getMetrics();
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            timestamp: new Date().toISOString(),
            url: window.location.href,
            metrics,
          }),
        }).catch((err) => console.warn('Error reportando métricas:', err));
      }, 5000);
    });
  }

  /**
   * Medir tiempo de una operación específica
   */
  measureOperation(name, fn) {
    const start = performance.now();
    try {
      const result = fn();
      const duration = performance.now() - start;
      console.log(`⏱️ ${name}: ${duration.toFixed(2)}ms`);
      return result;
    } catch (error) {
      const duration = performance.now() - start;
      console.error(`❌ ${name}: ${duration.toFixed(2)}ms (Error)`, error);
      throw error;
    }
  }

  /**
   * Medir operación async
   */
  async measureOperationAsync(name, fn) {
    const start = performance.now();
    try {
      const result = await fn();
      const duration = performance.now() - start;
      console.log(`⏱️ ${name}: ${duration.toFixed(2)}ms`);
      return result;
    } catch (error) {
      const duration = performance.now() - start;
      console.error(`❌ ${name}: ${duration.toFixed(2)}ms (Error)`, error);
      throw error;
    }
  }
}

export default new PerformanceMonitor();
